import { paginatedIndexRouteOptions } from './paginatedIndexQuery';

/**
 * Route helper utilities for Services (Usługi).
 *
 * Services are a single global resource (no site_context). They are managed
 * exclusively under the root /admin section.
 */
export function createServiceRouteHelper(_siteContext, routes) {
  return {
    index: (extra) => routes.admin_services(paginatedIndexRouteOptions(extra)),
    new: () => routes.new_admin_service(),
    edit: (id) => routes.edit_admin_service(id, paginatedIndexRouteOptions()),
    update: (id) => routes.admin_service(id, paginatedIndexRouteOptions()),
    destroy: (id) => routes.admin_service(id, paginatedIndexRouteOptions()),
    reorder: () => routes.reorder_admin_services(),
    bulkUpdateCategory: () => routes.bulk_update_category_admin_services(),
  };
}
